<div class="th-menulevel modal">
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(1)">
    <span>{{ 'menus.filereader.rename' | translate }}</span>
  </div>
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(2)">
    <span>{{ 'menus.filereader.replace' | translate }}</span>
  </div>
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(3)">
    <span>{{ 'menus.filereader.copy' | translate }}</span>
  </div>
  <div class="ir-btn ir-btn--big th-btn-remove" (click)="selectMenu(4)">
    <span>{{ 'menus.filereader.delete' | translate }}</span>
  </div>
</div>
